import isEmpty from 'validator/lib/isEmpty';
import isEmail from 'validator/lib/isEmail';
import isURL from 'validator/lib/isURL';
import { ValidationError } from 'react-vld';

export const validateRequiredString = (value, message = 'Required field!') => {
  if (isEmpty(value.trim())) {
    throw new ValidationError(message);
  }
};

export const validateEmail = (value, message = 'Invalid email address!') => {
  if (value && !isEmail(value)) {
    throw new ValidationError(message);
  }
};

export const validateURL = (value, message = 'Invalid URL!') => {
  if (value && !isURL(value)) {
    throw new ValidationError(message);
  }
};

export const validateEqualStrings = (str1, str2, message = 'Values do not match!') => {
  if (str1 !== str2) {
    throw new ValidationError(message);
  }
};

export const validateMinLength = (value, amount, message = 'Value can\'t be shorter than % characters!') => {
  if (value.length < amount) {
    throw new ValidationError(message.replace('%', amount));
  }
};



// WEBPACK FOOTER //
// ./src/utils/validation.js